import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateAdminUsers } from './state_admin_users';

export const local_admin_users_online_upsert = (payload: number): PayloadAction<number> => ({
  type: ENUM__redux_action.ADMIN_USERS_ONLINE_UPSERT,
  payload,
});

export const init_local_admin_users_online_upsert = (state: StateAdminUsers, action: PayloadAction<number>) => {
  state.users_online = action.payload;

  state.is_loaded = true;
};
